import Checkout from "../../errorCodes/Checkout"

export const checkoutErrorHandler = (errorCode: string) => {
  switch (errorCode) {
    case Checkout.NoCheckoutEmptyBasket:
      return "errors.PBCTANoCheckoutEmptyBasket"
    case Checkout.CreatePaymentFailed:
      return "errors.PBCTACreatePaymentFailed"
    default:
      return ""
  }
}
